import React from 'react';
import { FloatLabel } from '../../../Components';

interface AddressPartialFormProps<T> {
    values: T;
    onChange: <K extends keyof T>(field: K, value: T[K]) => void;
    onChangeNumberAddress?: (value: string) => void;
    errors?: Partial<Record<keyof T, string>>;
    dictAddressStreetLabel: string;
    dictAddressNumberLabel: string;
    dictAddressPostalLabel: string;
    dictAddressLocalityLabel: string;
    dictErrorSubmit: string;
}

const AddressPartialForm = <
    T extends {
        addressStreet: string;
        addressNumber: string;
        addressPostal: string;
        numberCompany: string;
        addressLocality: string;
    },
>({
    values,
    onChange,
    onChangeNumberAddress,
    errors,
    dictAddressStreetLabel,
    dictAddressNumberLabel,
    dictAddressPostalLabel,
    dictAddressLocalityLabel,
    dictErrorSubmit,
}: AddressPartialFormProps<T>) => {
    return (
        <div className="row">
            <div className="col-10">
                <FloatLabel
                    active={!!values.addressStreet}
                    label={dictAddressStreetLabel}
                    labelId="addressStreet"
                >
                    <input
                        type="text"
                        name="addressStreet"
                        value={values.addressStreet}
                        onChange={(e) =>
                            onChange('addressStreet', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressStreet && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-2">
                <FloatLabel
                    active={!!values.addressNumber}
                    label={dictAddressNumberLabel}
                    labelId="addressNumber"
                >
                    <input
                        type="text"
                        name="addressNumber"
                        value={values.addressNumber}
                        onChange={(e) =>
                            onChangeNumberAddress
                                ? onChangeNumberAddress(e.target.value)
                                : onChange('addressNumber', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressNumber && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-4">
                <FloatLabel
                    active={!!values.addressPostal}
                    label={dictAddressPostalLabel}
                    labelId="addressPostal"
                >
                    <input
                        type="text"
                        name="addressPostal"
                        value={values.addressPostal}
                        onChange={(e) =>
                            onChange('addressPostal', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressPostal && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-8">
                <FloatLabel
                    active={!!values.addressLocality}
                    label={dictAddressLocalityLabel}
                    labelId="addressLocality"
                >
                    <input
                        type="text"
                        name="addressLocality"
                        value={values.addressLocality}
                        onChange={(e) =>
                            onChange('addressLocality', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.addressLocality && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AddressPartialForm;
